import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";

(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.media = {


    attach: function (context, settings) {
      once("media", ".play-button", context).forEach(function (el) {
        $( ".play-button" ).click(function() {


          $(this).closest(".slide-media-container").find(".video-container").css("display", "block");
          $(this).closest(".slide-media-container").find(".image-container").css("display", "none");;
          $(this).closest(".slide-media-container").find('video').trigger('play');
          $(this).closest(".slide-media-container").find("iframe").height("480px");
          $(this).closest(".slide-media-container").find("iframe").width("100%");


        });
      });



    },
  };


  $('body').on('click', '.cs-share .cs-share-link', function(e){
    
    e.preventDefault();

    $('.cs-share-list', $(this).parents('.cs-share:first')).toggleClass('active');
    
    var url   = encodeURIComponent(window.location.href);
    var title = encodeURIComponent(document.title);
    var text  = encodeURIComponent(document.title + " — " + window.location.href);

    // URL per i servizi di sharing
    var linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}`;
    var facebookUrl        = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    var mailtoUrl   = `mailto:?subject=${title}&body=${text}`;
    var whatsappUrl = `https://wa.me/?text=${text}`;

    $('#share-linkedin').attr('href', linkedinUrl);
    $('#share-facebook').attr('href', facebookUrl);
    $('#share-whatsapp').attr('href', whatsappUrl);
    $('#share-email').attr('href', mailtoUrl);
  
  });

  // Bottone copia
  $('body').on('click', '#share-copy', function (e){
    e.preventDefault(); 
    ($(this).parents('.cs-share-list:first')).removeClass('active');

    try {
      navigator.clipboard.writeText(window.location.href);
    } catch (e) {
      // Fallback prompt
      var ok = prompt('Link: ', window.location.href);
      if (ok !== null) {
        btnCopy.innerText = 'Pronto da copiare';
        setTimeout(() => (btnCopy.innerText = 'Copia link'), 1500);
      }
    }
  });
    

})(jQuery, Drupal, drupalSettings);
